import { useMemo, useState, useCallback } from "react";
import { DialogContext } from "../contexts/DialogContext";

export default function DialogProvider({ children }: any) {
  const [state, setState] = useState({
    open: false,
    children: null,
    title: "",
  });

  const open = useCallback(async (title: string, children: any) => {
    setState((prevState) => ({
      ...prevState,
      open: true,
      children,
      title,
    }));
  }, []);

  const close = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      open: false,
      children: null,
      title: "",
    }));
  }, []);

  const value = useMemo(
    () => ({
      state,
      open,
      close,
    }),
    [close, open, state],
  );

  return (
    <DialogContext.Provider value={value}>{children}</DialogContext.Provider>
  );
}
